import { render, staticRenderFns } from "./ToplamBorcTutari.vue?vue&type=template&id=4888b68e&scoped=true"
import script from "./ToplamBorcTutari.vue?vue&type=script&lang=js"
export * from "./ToplamBorcTutari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888b68e",
  null
  
)

export default component.exports